import { colors } from "@mui/material";

export function NewlineText({ text }) {
  return text.split('\n').map(str => <p>{str}</p>);
}

export function Divider({ px = 1, color = "lightgrey" }) {
    return (
        <hr
            style={{ borderTop: `${px}px solid ${color}`, opacity: 1 }}
        ></hr>
    );
};